import { Component, Inject, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BitlockerKeysDialogData } from '../../../Interfaces/bitlocker-key.interface';
import { AvTableCard } from '../../../../Shared/Components/av-table-card/av-table-card.component';
import { AvTableColumn, AvTableRow, AvTableCopyCell } from '../../../../Shared/Interfaces/av-table-card.interface';
import { formatDate } from '../../../../Shared/Utils/date.utils';

@Component({
  selector: 'app-bitlocker-keys-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    TranslateModule,
    AvTableCard,
  ],
  templateUrl: './bitlocker-keys-dialog.component.html',
  styleUrls: ['./bitlocker-keys-dialog.component.scss', '../../../../../../assets/theme/cutom/_av-dialog.scss'],
})
export class BitlockerKeysDialogComponent {
  private readonly translate = inject(TranslateService);

  readonly columns: AvTableColumn[] = [
    { key: 'volumeType', label: 'app.device.actions.bitlocker_keys.volume_type', sortable: true },
    { key: 'createdDateTime', label: 'app.device.actions.bitlocker_keys.created', sortable: true },
    { key: 'key', label: 'app.device.actions.bitlocker_keys.recovery_key', type: 'copy' },
  ];

  rows: AvTableRow[] = [];

  constructor(
    public dialogRef: MatDialogRef<BitlockerKeysDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: BitlockerKeysDialogData
  ) {
    this.initializeRows(data);
  }

  private initializeRows(data: BitlockerKeysDialogData): void {
    const keys = Array.isArray(data?.keys) ? data.keys : [];
    this.rows = keys.map((item) => ({
      volumeType: this.getVolumeTypeLabel(item.volumeType),
      createdDateTime: formatDate(item.createdDateTime),
      key: {
        content: item.key ?? '',
        value: item.key,
        tooltip: 'app.device.actions.bitlocker_keys.recovery_key',
      } as AvTableCopyCell,
    }));
  }

  private static readonly VOLUME_TYPE_KEYS: Record<number, string> = {
    1: 'app.device.actions.bitlocker_keys.volume_types.operating_system',
    2: 'app.device.actions.bitlocker_keys.volume_types.fixed_data',
    3: 'app.device.actions.bitlocker_keys.volume_types.removable_data',
    4: 'app.device.actions.bitlocker_keys.volume_types.unknown',
  };

  private getVolumeTypeLabel(value: string | number | undefined): string {
    if (value === undefined || value === null) return '';
    const num = typeof value === 'string' ? parseInt(value, 10) : value;
    if (Number.isNaN(num)) return '';
    const key = BitlockerKeysDialogComponent.VOLUME_TYPE_KEYS[num];
    return key ? this.translate.instant(key) : '';
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
